export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || "http://localhost:3069/api";
export const CLOUDINARY_URL = import.meta.env.VITE_CLOUDINARY_URL || "https://res.cloudinary.com/dbeuf0pfl/image/upload/";
export const MAINTAINANCE_MODE = import.meta.env.VITE_MAINTENANCE_MODE || false;